export const BUILD_VERSION = '1790246259959';
